import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { isStaffRole } from "@contractorhub/shared";
import { homeFor } from "../../lib/auth";

/**
 * The pages a user admin shares with full admins (AUTH-13): the directory
 * (contractors, clients, projects), timesheet review, the chase list and
 * reports. Each one hides money from a user admin itself — the API has already
 * left it out. Everything else admin-side stays under `_admin`, which a user
 * admin cannot enter.
 */
export const Route = createFileRoute("/_authed/_staff")({
  beforeLoad: ({ context }) => {
    const role = context.user?.role;
    if (!role || !isStaffRole(role))
      throw redirect({ to: role ? homeFor(role) : "/login" });
  },
  component: () => <Outlet />,
});
